export default "__VITE_ASSET__Df_MPSam__"